export default ({ app }, inject) => {
  inject('localePath', (url) => app.localePath(url))
  inject('switchLocalePath', (lang) => app.switchLocalePath(lang))
}
